// AddHospitalTour.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addHospitalTour } from "../../Adapters/ApiAdapter";

const AddHospitalTour = () => {
  const [formData, setFormData] = useState({
    category_name: "",
    images: [""],
    videos: [""],
  });
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({ ...prev, images: [...prev.images, ...files] }));
  };

  const handleVideoChange = (index, value) => {
    const newVideos = [...formData.videos];
    newVideos[index] = value;
    setFormData({ ...formData, videos: newVideos });
  };

  const addMoreVideoField = () => {
    setFormData({ ...formData, videos: [...formData.videos, ""] });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const formDataPayload = new FormData();
  //     formDataPayload.append("category_name", formData.category_name);

  //     // Append each image file to formData
  //     for (let i = 0; i < formData.images.length; i++) {
  //       formDataPayload.append("images[]", formData.images[i]);
  //     }

  //     // Append video URLs as stringified array
  //     formDataPayload.append("videos", JSON.stringify(formData.videos.filter(Boolean)));

  //     const response = await addHospitalTour(formDataPayload);

  //     if (response.status === "true") {
  //       toast.success("Hospital tour added successfully!");
  //       setFormData({ category_name: "", images: [], videos: [""] });
  //     } else {
  //       toast.error(response.message || "Failed to add tour");
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataPayload = new FormData();
      formDataPayload.append("category_name", formData.category_name);

      // ✅ Append each image file under key `image[]`
      formData.images.forEach((file) => {
        formDataPayload.append("images[]", file);
      });

      // ✅ Append videos as JSON string array
      formDataPayload.append("video", JSON.stringify(formData.videos.filter(Boolean)));

      const response = await addHospitalTour(formDataPayload);

      if (response.status === "true") {
        toast.success("Hospital tour added successfully!");
        setFormData({ category_name: "", images: [], videos: [""] });
      } else {
        toast.error(response.message || "Failed to add tour");
      }
    } catch (error) {
      toast.error("An error occurred.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Box m={"20px"}>
      <ToastContainer />
      <Typography variant="h4">Add Hospital Tour</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Category Name"
          value={formData.category_name}
          onChange={(e) => setFormData({ ...formData, category_name: e.target.value })}
          required
        />

        <Typography variant="subtitle1">Upload Images</Typography>
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={handleFileChange}
        />

        <Typography variant="subtitle1" mt={2}>Video URLs</Typography>
        {formData.videos.map((video, index) => (
          <TextField
            key={index}
            fullWidth
            margin="normal"
            label={`Video URL ${index + 1}`}
            value={video}
            onChange={(e) => handleVideoChange(index, e.target.value)}
          />
        ))}
        <Button onClick={addMoreVideoField} style={{ background: '#0ca851' }}>+ Add More Video</Button><br />

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          style={{ background: '#0ca851' }}
          sx={{ mt: 3 }}
        >
          {loading ? <CircularProgress size={24} /> : "Add Tour"}
        </Button>
      </form>
    </Box>
  );
};

export default AddHospitalTour;
